import React from 'react';
import { fitnessProfileSurfaceCardClassName } from './fitnessProfileReadingStyles';

export default function FitnessProfileHealthMetricCard({ label, value }) {
	return (
		<div className={`${fitnessProfileSurfaceCardClassName} p-4`}>
			<div className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</div>
			<div className="mt-1 text-xl font-semibold text-gray-900 dark:text-gray-100">{value}</div>
		</div>
	);
}
